export default "__VITE_ASSET__CIk$jtc8__"